import AddCircleIcon from '@mui/icons-material/AddCircle';
import Grid from '@mui/material/Unstable_Grid2';
import { IconButton } from '@mui/material';
import React from 'react';
import styles from '../../../styles/TableComponent.module.css';
import { useTheme } from '@mui/material/styles';

interface AddColumnElementProps {
  lastColumn?: boolean;
}

export const AddColumnElement = (props: AddColumnElementProps) => {
  const muiTheme = useTheme();
  const primaryColor = muiTheme.palette.primary.main;
  return (
    <Grid container>
      <Grid>
        <IconButton
          size="small"
          color="primary"
          className={styles.addColumnButton}
          style={{
            transform: props.lastColumn
              ? `translate(5px, -18px)`
              : `translate(-5px, -18px)`
          }}
        >
          <AddCircleIcon />
        </IconButton>
      </Grid>
      <Grid
        style={{
          backgroundColor: `${primaryColor}`,
          transform: props.lastColumn ? `translateX(9px)` : `translateX(-1px)`
        }}
        className={styles.addColumnBar}
      ></Grid>
    </Grid>
  );
};
